
import { Divider, Grid } from '@mui/material';
import React, { useState } from 'react';
import authService from '../../services/authService';
import InstituteForm from '../manage-institute/instituteForm';
import Programs from '../manage-program/programs';
import GcComposition from './gcComposition';
import CustomTabs from '../common/customTabs';


const SynizaDepartment = () => {
    const [option, setOption] = useState(null)
    const [selected, setSelected] = useState("composition")
    // let option;
    function onClick(name) {
        //console.log("name trust info:",name);
        setSelected(name);
        setOption(getItem(name));
    }

    function getItem(name) {
        switch (name) {
            case "basicinfo":
                return <InstituteForm id={authService.getInstituteTenant()} />
            case "composition":
                return <GcComposition />
            case "program":
                return <Programs />
            default:
                break;
        }
    }

    function getTabs() {
        return [
            {
                name: "designation", label: "Designation"
            },
            {
                name: "teachinStaff", label: "Teaching Staff"
            },
            {
                name: "nonTeachingStaff", label: "Non-Teaching Staff"
            },
            {
                name: "holiday", label: "Holidays"
            },
            {
                name: "leavs", label: "Leaves"
            }
        ]
    }


    return (
        <>
            <Grid container columnSpacing={5}>
                {/* {getTabs().map(tab => <Grid item sm={4}>
                    {tab.name === selected ? <Button color='default' fullWidth variant='contained' onClick={() => onClick(tab.name)}> {tab.label} </Button> : <Button color='outlinedDefault' fullWidth variant='outlined' onClick={() => onClick(tab.name)}> {tab.label} </Button>}
                </Grid>)} */}

                <CustomTabs tabs={getTabs()} selected={selected} onClick={onClick} cols={3} />
            </Grid>
            <br />
            <Divider />
            <br />
            <Grid container item sm={12}>
                {getItem(selected)}
            </Grid>
        </>
    );
}

export default SynizaDepartment;